import React, { useCallback } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';

import {
  areRescheduleClassesAppliedFiltersPresentSelector,
  resetRescheduleFilters,
  setRescheduleClassesFilterModalState,
} from 'features/classCreation';
import RescheduleClassesFilterChips from '../RescheduleClassesFilterChips';

export default function RescheduleFilterSection() {
  const dispatch = useDispatch();
  const areAppliedFiltersPresent = useSelector(
    areRescheduleClassesAppliedFiltersPresentSelector
  );

  const handleAddFiltersClick = useCallback(() => {
    dispatch(setRescheduleClassesFilterModalState(true));
  }, [dispatch]);

  const handleClearFiltersClick = useCallback(() => {
    dispatch(resetRescheduleFilters());
  }, [dispatch]);

  if (areAppliedFiltersPresent) {
    return (
      <div className="m-t-xxs">
        <RescheduleClassesFilterChips />
        <Tappable
          noHighlight
          onClick={handleAddFiltersClick}
          className="primary m-l-xs h5 bold"
        >
          Add
        </Tappable>
        <Tappable
          noHighlight
          onClick={handleClearFiltersClick}
          className="primary m-l-xs h5 bold"
        >
          Clear filters
        </Tappable>
      </div>
    );
  } else {
    return (
      <div className="m-t-xxs">
        <Tappable
          className="btn btn-outlined btn-primary p-xxs"
          onClick={handleAddFiltersClick}
        >
          <Icon
            name="add"
            className="m-r-xxs h2 cursor"
          />
          Add Filters
        </Tappable>
      </div>
    );
  }
}
